export default {
  methods: {
    handlePrepareData (data, flag) {
      let prepareData = Object.assign(data, { companyID: this.companyID })
      return this.correctDataWithFieldID(prepareData)
    }
  }
}
